import React from 'react';
import { CertificateDownload } from 'src/features/CertificateDownload';
import { RatingWidgetDownload } from 'src/features/RatingWidgetDownload';
import { Heading } from 'src/shared/ui/Heading';
import s from 'src/widgets/CertificatesMC/ui/CertificatesMC.module.scss';

export const CertificatesMC: React.FC = () => {
	// * Render
	return (
		<>
			<Heading
				level={3}
				marginBottom="m"
			>
				Certificates & widgets
			</Heading>

			<div className={s.inner}>
				<CertificateDownload />
				<RatingWidgetDownload />
			</div>
		</>
	);
};
